import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	Divider,
	Icon,
	IconButton,
	InputAdornment,
	Switch,
	TextField,
	Typography,
	useTheme,
	Tooltip
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Search } from '@material-ui/icons'
import clsx from 'clsx'
import { cloneDeep } from 'lodash'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import debouncedInput from '../../services/debouncedInput'
import { sortByKey } from '../../utils'

const DebouncedTextField = debouncedInput(TextField, { timeout: 200 })

const useStyles = makeStyles((theme) => ({
	dialogPaper: {
		width: '75%',
		maxWidth: 920,
		padding: '0px',
		maxHeight: 650
	},
	dialogTitle: {
		padding: '24px 24px 16px 24px',
		'& h2': {
			fontSize: '16px',
			fontWeight: 800,
			lineHeight: '22px',
			textTransform: 'uppercase'
		}
	},
	searchFilterWrapper: {
		display: 'flex'
	},
	filterWrapper: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		flex: 1,
		borderRadius: 6,
		background: '#F9F9F9',
		padding: '0px 16px'
	},
	dialogContent: {
		padding: '0px 0px 0px 24px',
		marginRight: 8
	},
	label: {
		transform: 'translate(48px, 20px) scale(1) !important'
	},
	shrink: {
		transform: 'translate(48px, 10px) scale(0.75) !important'
	},
	searchInput: {
		paddingTop: 7,
		paddingBottom: 10
	},
	dialogActions: {
		justifyContent: 'flex-start',
		padding: '16px 24px',
		borderTop: '1px solid #D0CFD2'
	},
	block: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		marginBottom: 15
	},
	blockTitle: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		padding: '10px 0px',
		width: '100%',
		'& i': {
			marginRight: 15,
			color: '#D0CFD2'
		},
		'& .selected': {
			color: '#6B4AD6'
		},
		'& h4': {
			margin: 0
		}
	},
	dividerRoot: {
		background: '#D0CFD2'
	},
	blockMain: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'stretch',
		flexWrap: 'wrap'
	},
	kennel: {
		height: 57,
		// padding: '15px',
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'flex-start',
		justifyContent: 'space-between',
		borderWidth: 1,
		borderStyle: 'solid',
		borderColor: '#E5E5E5',
		flex: '210px 0 1',
		borderRadius: 6,
		marginRight: 8,
		marginBottom: 8,
		cursor: 'pointer',
		'&:not(.selected):hover': {
			borderWidth: 2,
			borderColor: '#6B4AD6',
			'& .MuiTypography-root': {
				color: '#6B4AD6 !important'
			}
		}
	},
	kennelInt: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'flex-start',
		paddingLeft: 15,
		paddingRight: 15,
		paddingTop: 8,
		paddingBottom: 8
	},
	kennelIntRight: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flext-start',
		alignItems: 'flex-end',
		paddingLeft: 15,
		paddingRight: 15,
		paddingTop: 6,
		paddingBottom: 8
	},
	selectedKennels: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		height: 50,
		'& i': {
			color: '#6B4AD6',
			fontSize: 18,
			marginRight: 15,
			cursor: 'pointer'
		},
		'& h4': {
			margin: 0,
			fontSize: 16,
			fontFamily: 'Nunito',
			color: '#1A1A35',
			fontWeight: '600'
		}
	},
	switchRoot: {
		width: 51,
		height: 31,
		padding: 0
	},
	switchBase: {
		padding: 0,
		margin: 2,
		'&$checked': {
			transform: 'translateX(20px)',
			color: theme.palette.common.white,
			'& .far::before': {
				color: '#6B4AD6'
			}
		},
		'&$checked + $track': {
			backgroundColor: '#6B4AD6',
			opacity: 1
		},
		'&$focusVisible $thumb': {
			color: '#6B4AD6',
			opacity: 1
		},
		'&.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
			backgroundColor: '#6B4AD6',
			opacity: 1
		},
		'&.MuiSwitch-switchBase.Mui-checked .far.fa-check::before': {
			color: '#6B4AD6'
		}
	},
	thumb: {
		width: 27,
		height: 27,
		background: '#FFFFFF',
		border: '1px solid #E5E5E5',
		borderRadius: '50%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		'& .far': {
			color: '#A2A1A4',
			fontSize: '13px',
			lineHeight: '15px'
		}
	},
	track: {
		borderRadius: 100,
		padding: 2,
		backgroundColor: '#D0CFD2',
		opacity: 1,
		transition: theme.transitions.create(['background-color'])
	}
}))

const KennelBlockDialogNew = (props) => {
	const classes = useStyles()
	const theme = useTheme()

	const visits = useSelector((state) => state.specific.visits.visits)

	const { isShown, setIsShown, facility, assignKennel, assignKennels, playgroup, pet } = props

	const time = 'day'
	const multiple = false

	const [selectedKennels, setSelectedKennels] = useState([])
	const [selectedKennel, setSelectedKennel] = useState(null)
	const [search, setSearch] = useState('')
	const [showOnlyAvailable, setShowOnlyAvailable] = useState(false)
	const [mappedKennels, setMappedKennels] = useState([])

	useEffect(() => {
		let kennel =
			pet && facility && facility.kennels
				? facility.kennels.find((k) => k.pet_ids.includes(pet._id))
				: null

		setSelectedKennel(kennel ? kennel.reference_number : null)

	}, [facility, playgroup, pet, isShown])

	useEffect(() => {
		let kens = getMappedKennels()
		setMappedKennels(kens)
	}, [facility, playgroup, pet, time])

	const getMappedKennels = () => {
		if (!facility || !facility.kennels) return []
		let kennel_types = facility.kennel_types || []
		let kennel_blocks = facility.kennel_blocks || []
		return facility.kennels.map((k) => {
			let type = kennel_types.find((kt) => kt._id === k.kennel_type_id)
			return {
				...k,
				kennel_type: type || {}
			}
		})
	}

	const selectAllKennels = (block) => {
		let blockKennelsReferenceNumbers = facility.kennels
			.filter((k) => k.kennel_block_id === block._id)
			.map((k) => k.reference_number)

		let areAllSelected = blockKennelsReferenceNumbers.every((r) => selectedKennels.includes(r))

		if (areAllSelected) {
			setSelectedKennels(selectedKennels.filter((r) => !blockKennelsReferenceNumbers.find((rn) => rn === r)))
		} else {
			let blockKennelsReferenceNumbersNotSelected = blockKennelsReferenceNumbers.filter(
				(r) => !selectedKennels.find((k) => k === r)
			)
			setSelectedKennels([...selectedKennels, ...blockKennelsReferenceNumbersNotSelected])
		}
	}

	const getSelectedKennels = () => {
		return (
			<div className={classes.selectedKennels}>
				<Icon
					className={selectedKennels.length ? 'fas fa-minus-square' : 'far fa-square'}
					style={{
						fontSize: 18,
						marginRight: 16,
						cursor: 'pointer',
						color: selectedKennels.length ? '#6B4AD6' : '#D0CFD2'
					}}
					onClick={() => setSelectedKennels([])}
				/>
				<Typography
					variant="h6"
					style={{
						fontSize: '16px',
						fontWeight: 800,
						lineHeight: '22px',
						textTransform: 'none'
					}}>
					{selectedKennels.length} Kennel
					{selectedKennels.length !== 1 ? 's' : ''} Selected
				</Typography>
			</div>
		)
	}

	return (
		<Dialog
			open={isShown}
			aria-labelledby="form-dialog-title"
			style={{
				zIndex: 10001
			}}
			PaperProps={{
				classes: {
					root: classes.dialogPaper
				}
			}}
			onClose={() => {
				setIsShown(false)
			}}>
			{/* <DialogTitle
				classes={{
					root: classes.dialogTitle
				}}>
				{time && time === 'night' ? 'Night ' : ''}Kennel Assignment
			</DialogTitle> */}
			<div className={classes.dialogTitle}>
				<div
					style={{
						display: 'flex',
						flexDirection: 'row',
						alignItems: 'center'
					}}>
					<Typography
						style={{
							color: '#1A1A35',
							fontSize: '16px',
							fontWeight: '800',
							lineHeight: '22px',
							marginRight: 17
						}}>
						{time && time === 'night' ? 'Night ' : ''}Kennel Assignment
					</Typography>
					<Typography
						style={{
							color: '#5F38BE',
							fontSize: '12px',
							fontWeight: '800',
							lineHeight: '16px',
							textTransform: 'uppercase'
						}}>
						{playgroup?.name}
					</Typography>
				</div>
			</div>
			<div
				style={{
					padding: '0px 24px 14px 24px'
				}}>
				<div className={classes.searchFilterWrapper}>
					<DebouncedTextField
						variant="filled"
						value={search}
						style={{ marginRight: 8 }}
						InputLabelProps={{
							shrink: false,
							classes: {
								root: classes.label,
								shrink: classes.shrink
							}
						}}
						InputProps={{
							placeholder: 'Search',
							startAdornment: (
								<InputAdornment position="start" style={{ marginLeft: 12 }}>
									<Search
										style={{
											fill: '#777679',
											stroke: '#777679',
											strokeWidth: '1px',
											marginTop: '-3px'
										}}
									/>
								</InputAdornment>
							),
							classes: {
								input: classes.searchInput
							}
						}}
						onChange={(e) => setSearch(e.target.value)}
					/>
					<div className={classes.filterWrapper}>
						<Typography variant="caption" component="span">
							Show only available
						</Typography>
						<Switch
							checked={showOnlyAvailable}
							onChange={() => {
								setShowOnlyAvailable(!showOnlyAvailable)
							}}
							name="showOnlyAvailable"
							icon={
								<div className={classes.thumb}>
									<Icon className="far fa-times" />
								</div>
							}
							checkedIcon={
								<div className={classes.thumb}>
									<Icon className="far fa-check" />
								</div>
							}
							classes={{
								root: classes.switchRoot,
								switchBase: classes.switchBase,
								thumb: classes.thumb,
								track: classes.track,
								checked: classes.checked
							}}
						/>
					</div>
				</div>

			</div>
			<DialogContent
				classes={{
					root: classes.dialogContent
				}}>
				{facility.kennel_blocks
					.map((a) => {
						let kennels = mappedKennels.filter(
							(k) => k.kennel_block_id === a._id && k.status !== 'disabled' && !k.kennel_type.crate
						)

						return {
							...a,
							kennels
						}
					})
					.filter((kb) => kb.kennels && kb.kennels.length && kb.status !== 'disabled')
					.filter((a) => {
						let { kennels } = a

						if (search) {
							return (
								search &&
								(a.name.includes(search) ||
									kennels.some((k) => k.reference_number.includes(search)))
							)
						} else {
							return true
						}
					})
					.map((block, index) => {
						let blockKennelsReferenceNumbers = block.kennels.map((k) => k.reference_number)

						let areSomeBlockKennelsSelected = blockKennelsReferenceNumbers.length
							? blockKennelsReferenceNumbers.some((k) => selectedKennels.includes(k))
							: false
						let areAllBlockKennelsSelected = blockKennelsReferenceNumbers.length
							? blockKennelsReferenceNumbers.every((k) => selectedKennels.includes(k))
							: false

						return (
							<div key={'kennelBlockDialogNew-' + index} className={classes.block}>
								<div className={classes.blockTitle}>
									{multiple ? (
										<IconButton
											style={{
												padding: 0,
												marginRight: 16
											}}
											disabled={!blockKennelsReferenceNumbers.length}
											disableRipple
											onClick={() => selectAllKennels(block)}>
											<Icon
												className={
													areAllBlockKennelsSelected
														? 'fas fa-check-square'
														: areSomeBlockKennelsSelected
															? 'fas fa-minus-square'
															: 'far fa-square'
												}
												style={{
													fontSize: 18,
													cursor: 'pointer',
													color:
														areSomeBlockKennelsSelected || areAllBlockKennelsSelected
															? '#6B4AD6'
															: '#D0CFD2'
												}}
											/>
										</IconButton>
									) : null}
									<Typography variant="h6" style={{ fontSize: 16 }}>
										{block.name}
									</Typography>
								</div>

								<div className={classes.blockMain}>
									{mappedKennels
										.filter((k) =>
											showOnlyAvailable
												? multiple
													? Object.keys(k.pet_ids).every(
														(t) => k.pet_ids.length === 0
													)
													: k.pet_ids.length === 0
												: true
										)
										.filter((k) => {
											if (multiple) {
												return k.status !== 'disabled'
											} else {
												return k.status !== 'disabled' && !k.kennel_type.crate
											}
										})
										.filter(
											(k) =>
												k.kennel_block_id === block._id &&
												(search ? k.reference_number.includes(search) : true)
										)
										.sort(sortByKey((k) => k.reference_number))
										.map((kennel, j) => {
											let selected = multiple
												? selectedKennels.includes(kennel.reference_number)
												: selectedKennel === kennel.reference_number

											let available

											if (!multiple) {
												available = kennel?.pet_ids?.length ? false : true

											} else {
												available = !kennel.playgroup_id
											}

											let text = available ? 'Available' : 'In Use'
											if (!multiple) {
												text = available ? 'Unassigned' : 'Assigned'
											}

											return (
												<div
													key={'kennel-' + j}
													className={clsx(classes.kennel, selected ? 'selected' : '')}
													style={{
														borderColor: selected && '#6B4AD6',
														borderWidth: selected ? 2 : 1
													}}
													onClick={() => {
														if (multiple) {
															let updated = cloneDeep(selectedKennels)

															if (selected) {
																updated = updated.filter(
																	(k) => k !== kennel.reference_number
																)
															} else {
																updated = [...updated, kennel.reference_number]
															}

															setSelectedKennels(updated)
														} else {
															setSelectedKennel(kennel.reference_number)
														}
													}}>
													<div className={classes.kennelInt}>

														<Typography
															variant="caption"
															style={{
																color: selected ? '#6B4AD6' : '#4D4C4F',
																fontWeight: 600,
																fontSize: 14
															}}>
															{text}
														</Typography>

														<Typography
															variant="caption"
															style={{
																color: selected ? '#6B4AD6' : '#4D4C4F',
																fontWeight: 600,
																fontSize: 14
															}}>
															{kennel.kennel_type?.name}
														</Typography>
													</div>
													<div className={classes.kennelIntRight}>
														<Typography
															variant="h6"
															style={{
																color: selected ? '#6B4AD6' : '#4D4C4F',
																fontWeight: 600,
																fontSize: 16
															}}>
															{kennel.reference_number}
														</Typography>
													</div>
												</div>
											)
										})}
								</div>
							</div>
						)
					})}
			</DialogContent>
			<DialogActions
				classes={{
					root: classes.dialogActions
				}}>
				<Button
					variant="contained"
					onClick={() => {
						if (multiple) {
							if (assignKennels && typeof assignKennels === 'function')
								assignKennels(selectedKennels)
						} else {
							let kennel = facility.kennels.find((k) => k.reference_number === selectedKennel)
							if (kennel && assignKennel && typeof assignKennel === 'function') assignKennel(kennel)
						}
					}}
					color="secondary">
					SAVE
				</Button>
				<Button
					variant="outlined"
					onClick={() => {
						setIsShown(false)
					}}
					color="secondary">
					CANCEL
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default KennelBlockDialogNew
